// HTML DOM Content
document.getElementById('modalExample1').addEventListener('click', () => {
	ui.modal('#modalWithTriggerElement');
});
// HTML String Content
const btn = document.getElementById('modalExample2');
btn.addEventListener('click', () => {
	ui.modal('<div id="modalExampleContents2" class="modal"><p>This modal was created by passing an HTML string at the time of initailization.</p></div>', { trigger: '#modalExample2' });
});
// Loading Modal
document.getElementById('modal8Btn').addEventListener('click', () => {
	ui.modal('<div class="modal" id="modal8" data-title="Please wait..."></div>', {
		onOpen: () => {
			setTimeout(() => {
				const baconModal = ui.modal('<div><p>Bacon ipsum dolor sit amet tri-tip drumstick leberkas beef corned beef tenderloin meatloaf pork bresaola shank venison. Flank doner tenderloin hamburger jowl.</p><div class="topSpacing"><button class="ancBtn" type="button" id="modalLoad1">Confirm</button></div></div>', {
					onOpen: () => {
						document.getElementById('modalLoad1').addEventListener('click', () => {
							baconModal.element.innerText = '';
							ui.modal.showLoading(true);
							setTimeout(() => {
								ui.modal('<p>Congratulations! Your response has been confirmed.</p>');
							}, 2500);
						});
					}
				});
			}, 2500);
		},
		showLoading: true,
		trigger: '#modal8Btn'
	});
});
// Chaining Modals
const chainStart = document.getElementById('modal7Btn');

chainStart.addEventListener('click', () => {
	ui.modal('#modalChain1', {
		onOpen: () => {
			document.getElementById('modalNext1').addEventListener('click', () => {
				ui.modal('#modalChain2', {
					onOpen: () => {
						document.getElementById('modalNext2').addEventListener('click', () => {
							ui.modal('#modalChain3');
						});
					},
					width: 300
				});
			});
		},
		trigger: chainStart,
		width: 800
	});
});



// WEBPACK FOOTER //
// ./src/components/modal/modal.demo.js